import { useQuery } from '@tanstack/react-query'
import { getPersonaIdPhoto } from 'api/user'
import { userKey } from './keys'

export function usePersonaIdPhoto(
  userId: string | undefined,
  { enabled = false }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: [...userKey, userId, 'personaIdPhoto'],
    queryFn: () => getPersonaIdPhoto(userId!),
    enabled: enabled && !!userId,
    retry: false,
    staleTime: Infinity,
  })
}
